export default __webpack_public_path__ + "static/media/LBMA_Median_Accuracy.a07cd2bd.png";